import React, { ButtonHTMLAttributes } from "react";
import "./styles.scss";
import SmartButton from "../SmartButton";

interface ConfirmAlertProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    title?: string;
    message: string;
    onConfirm: () => void;
    onCancel?: () => void;
}

const ConfirmAlert = (props: ConfirmAlertProps): JSX.Element => {
    const { title, message, onCancel, onConfirm } = props;

    return (
        <div className="confirm-alert-custom-ui">
            {!!title && <h1>{title}</h1>}
            <p>{message}</p>
            <div className="btn-group">
                <SmartButton mode="primary" onClick={onConfirm}>
                    はい
                </SmartButton>
                {!!onCancel && (
                    <SmartButton mode="cancel" onClick={onCancel}>
                        キャンセル
                    </SmartButton>
                )}
            </div>
        </div>
    );
};

export default ConfirmAlert;
